import type { FaireProductEntity } from "../../entity_types/product";

export const p_yp4adgedtz: FaireProductEntity = {
  token: "p_yp4adgedtz",
  type: "product",
  name: "Okloveyoubye Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/6e6c5435f2f38f1b12d68e6d54c8cd4091ff69427e46baea2be5e57b42a3ef3a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/10d8dcbe27d535cbfdafc15c1f2d7e43f559418dceb8c55c39e8d601807e8ad2.jpeg",
    "https://cdn.faire.com/fastly/1b06da838355e26b084a01c335ede9428bafc5a56f9bb45bc5c0145176b028f6.jpeg"
  ],
  priceDollars: 8,
  description: "A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be \"well-edited\" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:26.665Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
